// Navbar
import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorBoundary from '../../ErrorBoundary';

const Wrapper = styled.div`
  width: 100%;
  .uk-navbar-nav > li > a {
    min-height: 80px;
    height: 80px;
    @media (orientation: landscape) and (max-height: 600px) {
      min-height: 50px;
      height: 50px;
    }
  }
  nav {
    margin-left: auto;
    margin-right: auto;
  }
`;
export default class Navbar extends Component {
  static propTypes = {};

  render() {
    return (
      <ErrorBoundary>
        <Wrapper className="nav-navbar uk-background-secondary-gradient uk-visible@m">
          <div data-uk-sticky="animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; cls-inactive: uk-navbar-transparent uk-light; top: 200; align: center;">
            <div className="uk-navbar-container uk-box-shadow-small" aria-label="Main Navigation">
              <ul
                className="uk-navbar-nav uk-flex-around uk-flex-1 uk-text-top"
                data-uk-scrollspy-nav="closest: li;"
              >
                <li className="uk-active">
                  <a data-uk-smooth-scroll href="#home" aria-current="page">
                    Home
                  </a>
                </li>
                <li>
                  <a data-uk-smooth-scroll href="#framing" aria-current="page">
                    Custom Framing
                  </a>
                </li>
                <li>
                  <a data-uk-smooth-scroll href="#gifts" aria-current="page">
                    Gifts & More
                  </a>
                </li>
                <li>
                  <a data-uk-smooth-scroll href="#holidays" aria-current="page">
                    Holidays
                  </a>
                </li>
                <li>
                  <a data-uk-smooth-scroll href="#pond" aria-current="page">
                    The Pond
                  </a>
                </li>
                <li>
                  <a data-uk-smooth-scroll href="#contact" aria-current="page">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Wrapper>
      </ErrorBoundary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/nav/Navbar.js